import { Coordinates } from 'src/api/defs/Coordinates.type'
import { Option } from 'src/ui/basic/api/OptionsInput'

export type Coords = Coordinates & { name?: string }

export const parseCoord = (p: string): Coords => {
    const splitted = p.split(',')
    if (splitted.length !== 2) throw new Error('Illegal Coord string form')
    return {
        lat: parseFloat(splitted[0]),
        lng: parseFloat(splitted[1])
    }
}

export const serializeCoord = (c: Coords) => `${c.lat},${c.lng}`

export const coordOptions: Record<string, Option<Coords>> = {
    BratislavaDlheDiely: {
        label: 'Bratislava IV.- Dlhé diely',
        value: {
            lat: 48.151711,
            lng: 17.049741
        }
    },
    BratislavaCentrum: {
        label: 'Bratislava I.- Mamut',
        value: {
            lat: 48.147156,
            lng: 17.121303
        }
    },
    Praha4: {
        label: 'Praha 4- 5.května',
        value: {
            lat: 50.0604065189894,
            lng: 14.4326312999993
        }
    },
    Praha2Sobeslavska: {
        label: 'Praha 2- Soběslavská',
        value: {
            lat: 50.07832,
            lng: 14.47078
        }
    },
    Praha6Slanska: {
        label: 'Praha 6- Slánska',
        value: {
            lat: 50.06588,
            lng: 14.30788
        }
    },
    Praha9CernyMost: {
        label: 'Praha 9- Černý Most',
        value: {
            lat: 50.10285,
            lng: 14.57819
        }
    }
}
